import React from 'react';
import OrderListTable from '../Components/Order/OrderListTable';
import { useGetOrdersQuery} from '../Api/Api';
import FullPageSpinner from '../Components/Spinner/FullPageSpinner';
import { IOrderDetails } from '../Api/Models/Order';
import OrderDetailsPanel from '../Components/Order/OrderDetailsPanel';
import { SK_FIRST_NAME, SK_LAST_NAME } from '../Constants/LocalStorageKeys';
import CAN, {ORDERS} from "../Components/Auth/Permissions";
import { useNavigate } from 'react-router-dom';
import { useLocalization } from '../Components/Helpers/useLocalization';

const AccountDetailsPage: React.FC = () => {
    const orderList = useGetOrdersQuery();
    const L = useLocalization();
    const [selectedOrder, setSelectedOrder] = React.useState<IOrderDetails | undefined>(undefined);
    const name = localStorage.getItem(SK_FIRST_NAME) != null || localStorage.getItem(SK_LAST_NAME) != null
        ? (localStorage.getItem(SK_FIRST_NAME) ?? '') + ' ' + (localStorage.getItem(SK_LAST_NAME) ?? '')
        : null;

    const navigate = useNavigate();

    const canPlaceOrder = CAN(ORDERS);
    if (!canPlaceOrder) {
        navigate('/')
    }

    const closeOrderDetails = () => {
        setSelectedOrder(undefined);
    }

    if (orderList.isLoading) return <FullPageSpinner />
    return (
        <div>
            <h1>{L('localization_order_account_details_title')}{name && <span> - {name}</span>}</h1>
            <OrderListTable orders={orderList.data?.data ?? []} onDetailsSelected={setSelectedOrder} />
            <OrderDetailsPanel order={selectedOrder} onDismiss={closeOrderDetails} />
        </div>
    );
}

export default AccountDetailsPage;